import { Request } from '@/classes/Request'

export interface AchSession {
  session_key: string
  expires_at: string | null
}

// POST /ajax/funding_sources/ach_session
// Core mints a single-use tokenization session at the payment API and binds it
// to the authenticated family. The browser then seals the bank payload to the
// pinned relay public key and hands the opaque blob back to core (raw bank never
// reaches core in readable form).
export const achSession = async (districtId: number): Promise<AchSession> => {
  const response = await new Request().post('/ajax/funding_sources/ach_session', {
    district_id: districtId
  })
  return response.data
}

// POST /ajax/funding_sources/add_tsys_ach
// Hand core the session_key + the RSA-OAEP-sealed bank blob (enc_payload) +
// billing. Core relays the opaque blob server-to-server to the payment API's
// tokenize endpoint and stores the AUTHORITATIVE token it returns — core never
// reads the blob, and there is no browser-relayed token.
// Deliberately NOT wrapped in a re-thrown string. Concatenating the error threw
// away the response body, so core's actual validation messages ("Failed
// validation rules - {...}", "Invalid or expired tokenization session.") never
// reached the console and every failure looked identical to the family.
export const addTsysAch = async (payload: object): Promise<void> => {
  await new Request().post('/ajax/funding_sources/add_tsys_ach', payload)
}
